module.exports = __webpack_public_path__ + "static/media/krx-past.e5ed43b7.jpg";